import React from "react";
import classes from "./FooterSocialLinks.module.css";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import facebook from "./../../assets/images/colored-facebook.svg";
import instagram from "./../../assets/images/colored-instagram.svg";
import tiktok from "./../../assets/images/colored-tiktok.svg";
function SocialLinks() {
  return (
    <div className={`${classes.container} pt-0 pb-2`}>
      <div className={classes.social_links}>
        <div className={classes.social_link}>
          <Link
            to="https://web.facebook.com/sofiasls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={facebook} className={classes.icon} alt="Facebook" />
          </Link>
        </div>
        <div className={classes.social_link}>
          <Link
            to="https://www.instagram.com/sls.immobilier"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={instagram} className={classes.icon} alt="Instagram" />
          </Link>
        </div>
        <div className={classes.social_link}>
          <Link
            to="https://www.tiktok.com/@slsimmob"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={tiktok} className={classes.icon} alt="Twitter" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SocialLinks;
